import { Component, OnInit } from '@angular/core';
import { AlertListService, QueryStringService, ApiService } from '@xref/ngx';
import { environment } from '../../../environments/environment';
import { EmployerOverviewService } from '../../services/employer-overview/employer-overview.service';
import { OauthService } from '../../services/oauth/oauth.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import * as Cookies from 'js-cookie';
import constants from 'src/app/shared/constants';
import {IdService} from "../../services/id/id.service";


@Component({
    selector: 'xlog-oauth-checkr',
    templateUrl: './oauth-checkr.component.pug',
    styleUrls: ['./oauth-checkr.component.scss'],
    standalone: false
})
export class OauthCheckrComponent implements OnInit {
    loading = false;
    error = false;

    checkrOauthPostData: any = {};
    hideButton = true;
    checkrRedirect = environment.OAUTH_CHECKR_REDIRECT;

    constructor(
        private oauth: OauthService,
        private api: ApiService,
        private employerOverview: EmployerOverviewService,
        private qString: QueryStringService,
        private alertList: AlertListService,
        private jwtHelper: JwtHelperService,
        private id: IdService
    ) {}

    ngOnInit() {
        this.loading = true;

        if (this.id.ent_9105) {
            this.id.getAuthToken();
        }

        this.setCheckrPostData();

        this.setRegionalUrl();

        this.employerOverview.getEmployerOverview(() => {
            this.checkrOauthPostData.company_id = this.employerOverview.data.company_id;

            this.oauth.connectCheckr(this.checkrOauthPostData)
                .subscribe(this.checkrConnectSuccess, this.checkrConnectFailed);
        });
    }

    setCheckrPostData() {
        const companyId = this.oauth.getCheckrStateParam().companyId;

        this.checkrOauthPostData.code = this.qString.getParam('code');
        this.checkrOauthPostData.state = parseInt(companyId, 10);
    }

    connectCheckr() {
        this.oauth.connectCheckr(this.checkrOauthPostData)
            .subscribe(
                this.checkrConnectSuccess,
                this.checkrConnectFailed
            );
    }

    setRegionalUrl() {
        const token = this.jwtHelper.decodeToken(this.id.ent_9105 ? sessionStorage.getItem(constants.AUTH_TOKEN)
            : Cookies.get(constants.AUTH_TOKEN));

        if (token && token.hasOwnProperty('region')) {
            // Regional url for api-app
            this.api.setRegionalUrl(token.region, environment.API);
        }
    }

    private checkrConnectSuccess = (response: any) => {
        this.loading = false;

        if (response.status === 208 || response.credentialed) {
            this.error = false;
            this.oauth.checkrAppRedirect();

        } else {
            // Connected, but not credentialed
            this.error = true;

            this.alertList.append([{
                messageKey: 'oauth.checkr.alerts.checkrAccountPending',
                type: 'success',
                timeout: 0
            }]);

            this.hideButton = false;
        }
    };

    private checkrConnectFailed = (error: any) => {
    // Show error for failed connection
        this.loading = false;
        this.error = true;
        this.hideButton = false;

        this.handleConnectError(error.status);
    };

    private handleConnectError(status: number) {
        switch (status) {
            case 400:
                // Something wrong with request data
                this.alertList.append([{
                    messageKey: 'oauth.checkr.alerts.clientError',
                    type: 'danger',
                    timeout: 0
                }]);
                break;
            case 401:
                this.alertList.append([{
                    messageKey: 'oauth.checkr.alerts.unauthorized',
                    type: 'danger',
                    timeout: 0
                }]);
                break;
            case 500:
            default:
                this.alertList.append([{
                    messageKey: 'alerts.generic.error',
                    type: 'danger',
                    timeout: 0
                }]);
                break;
        }
    }
}
